import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import './ModalDialog.css';
import React, { useEffect, useRef, useState } from 'react';
import Screen from './Screen';
import { registerKeyHandler, unregisterKeyHandler } from './GlobalKeyHandler';
import { globalBlur, globalFocus } from '../helpers/dom';
const ModalDialog = ({ show, title, children, onClose, closeButton, minWidth, onConfirm, className, closeOnBackgroundClick, topRightIcon, closeFocus }) => {
    const ref = React.createRef();
    const idNum = useState(Math.floor(Math.random() * 1000000))[0];
    // Element focused before the dialog opened, restored on close so focus returns to
    // whatever triggered it (e.g. a context-menu button). Explicit closeFocus wins.
    const openerRef = useRef(null);
    const prevShowRef = useRef(false);
    const restoreFocus = () => { var _a; return globalFocus((_a = closeFocus !== null && closeFocus !== void 0 ? closeFocus : openerRef.current) !== null && _a !== void 0 ? _a : undefined); };
    useEffect(() => {
        var _a;
        if (show) {
            if (!prevShowRef.current)
                openerRef.current = document.activeElement;
            prevShowRef.current = true;
            registerKeyHandler('modalDialog', {
                'Escape': () => {
                    var _a;
                    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.close();
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                    restoreFocus();
                    return show;
                },
                ...onConfirm && { 'Enter': () => {
                        var _a;
                        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.close();
                        onConfirm();
                        restoreFocus();
                        return show;
                    } },
                'ArrowDown': () => {
                    // Exclude .touchOnly (mirrors focusFirstInForm): a DropDownSelector renders a hidden
                    // touch-device <select> first, and focusing that goes nowhere on desktop.
                    const p = document.querySelector(`#id${idNum} .flowFocussable:not(.sidewayFocus):not(.close):not(.touchOnly)`);
                    p && globalFocus(p);
                    return show;
                }
            }, true, 1000);
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.showModal();
            globalBlur();
        }
        // Closing via a content button (Cancel/Save) calls onClose directly and unmounts
        // the dialog, so its native onClose never fires — restore focus on the hide
        // transition itself to cover every close path.
        else if (prevShowRef.current) {
            prevShowRef.current = false;
            restoreFocus();
        }
        return () => {
            unregisterKeyHandler('modalDialog');
        };
    }, [show]);
    return (_jsx(_Fragment, { children: show &&
            _jsx(_Fragment, { children: _jsx("dialog", { ref: ref, id: `id${idNum}`, className: `modalDialog flowFormModal ${className !== null && className !== void 0 ? className : ''}`, style: { minWidth: minWidth }, onClose: () => { restoreFocus(); onClose === null || onClose === void 0 ? void 0 : onClose(); }, onClick: closeOnBackgroundClick ? (e) => { restoreFocus(); (e.target instanceof HTMLDialogElement) && (onClose === null || onClose === void 0 ? void 0 : onClose()); } : undefined, children: _jsx(Screen, { title: title, onClose: onClose, closeButton: closeButton, topRightIcon: topRightIcon, children: children }) }) }) }));
};
export default ModalDialog;
